import { api } from '../../api/api.paths';
import types from '../../types/actions';

export const refreshToken = async (refreshToken: string, dispatch: any, callback: () => void) => {
	try {
		const res = await fetch(import.meta.env.VITE_API_URL + api.refreshToken, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ refreshToken }),
		});
		const data = await res.json();
		dispatch({ payload: data, type: types.REFRESH_TOKEN_SUCCESS });
	} catch (error) {
		dispatch({ payload: error, type: types.REFRESH_TOKEN_FAILURE });
	}

	return callback();
};

export interface IRegisterPayload {
	acceptTerms: boolean;
	email: string;
	password: string;
	terms_2: boolean;
}
